<template>
  <v-container fluid class="billing">
    <v-card>
      <v-toolbar flat>
        <v-toolbar-title>
          <v-btn text small @click="$router.back()">
            <v-icon left> mdi-arrow-left </v-icon>
            Back
          </v-btn>
        </v-toolbar-title>

        <v-spacer />
        Billing Address
        <v-spacer />

        <v-btn @click="dialog = true" small text color="primary">
          <v-icon>mdi-plus</v-icon>
          Add Billing Address
        </v-btn>
      </v-toolbar>
    </v-card>
    <v-card flat class="mt-4">
      <v-card-text>
        <v-row>
          <v-col
            cols="12"
            md="6"
            sm="12"
            v-for="(address, i) in billingAddresses"
            :key="i"
          >
            <v-list>
              <v-list-item-group>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ `${address.firstName} ${address.lastName} ` }}
                      {{
                        address.companyName ? `(${address.companyName})` : ""
                      }}
                    </v-list-item-title>
                    <v-list-item-subtitle class="caption">
                      {{
                        `${address.country}, ${address.city}, ${address.postalCode}`
                      }}
                    </v-list-item-subtitle>
                    <v-list-item-subtitle class="caption">
                      <v-chip-group>
                        <v-chip x-small>
                          {{ `Email: ${address.email}` }}
                        </v-chip>

                        <v-chip x-small>
                          {{ `Phone: ${address.phone}` }}
                        </v-chip>

                        <v-chip x-small>
                          {{ `Address: ${address.address1}` }}
                        </v-chip>
                      </v-chip-group>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn color="blue" small icon @click="edit(address)">
                      <v-icon small>mdi-pencil</v-icon>
                    </v-btn>
                    <v-btn small icon color="error" @click="remove(address)">
                      <v-icon small>mdi-trash-can</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>

                <v-list-item disabled v-if="billingAddresses.length === 0">
                  <v-list-item-content>
                    <v-list-item-title class="text-center font-italic">
                      No Address found
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-dialog
      transition="dialog-top-transition"
      max-width="600px"
      v-model="dialog"
      persistent
    >
      <v-card>
        <v-toolbar dark flat color="primary">
          <v-toolbar-title> Add Billing Address </v-toolbar-title>
        </v-toolbar>

        <v-divider />
        <v-card-text class="pt-10 px-10">
          <v-row>
            <v-col cols="12" md="6" class="py-0">
              <v-text-field
                outlined
                dense
                label="First Name"
                v-model="formData.firstName"
                :rules="rules.firstName"
                ref="firstName"
              />
            </v-col>
            <v-col cols="12" md="6" class="py-0">
              <v-text-field
                outlined
                dense
                label="Last Name"
                v-model="formData.lastName"
                :rules="rules.lastName"
                ref="lastName"
              />
            </v-col>
            <v-col cols="12" md="6" class="py-0">
              <v-text-field
                outlined
                dense
                label="Email Address"
                v-model="formData.email"
                :rules="rules.email"
                ref="email"
              />
            </v-col>
            <v-col cols="12" md="6" class="py-0">
              <v-text-field
                outlined
                dense
                label="Phone Number"
                :rules="rules.phone"
                ref="phone"
                v-model="formData.phone"
              />
            </v-col>
            <v-col cols="12" class="py-0">
              <v-text-field
                outlined
                dense
                label="Company Name"
                v-model="formData.companyName"
                :rules="rules.companyName"
                ref="companyName"
              />
            </v-col>
            <v-col cols="12" class="py-0">
              <v-text-field
                outlined
                dense
                label="Address 1"
                v-model="formData.address1"
                :rules="rules.address1"
                ref="address1"
              />
            </v-col>
            <v-col cols="12" class="py-0">
              <v-text-field
                outlined
                dense
                label="Address 2"
                v-model="formData.address2"
                :rules="rules.address2"
                ref="address2"
              />
            </v-col>
            <v-col cols="12" md="4" class="py-0">
              <v-text-field
                outlined
                dense
                label="Country"
                v-model="formData.country"
                :rules="rules.country"
                ref="country"
              />
            </v-col>
            <v-col cols="12" md="4" class="py-0">
              <v-text-field
                outlined
                dense
                label="City"
                v-model="formData.city"
                :rules="rules.city"
                ref="city"
              />
            </v-col>
            <v-col cols="12" md="4" class="py-0">
              <v-text-field
                outlined
                dense
                label="Postal Code"
                v-model="formData.postalCode"
                :rules="rules.postalCode"
                ref="postalCode"
              />
            </v-col>
            <v-col cols="12" class="py-0">
              <v-text-field
                outlined
                dense
                label="VAT No."
                v-model="formData.pinNo"
                :rules="rules.pinNo"
                ref="pinNo"
              />
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions class="px-10 pb-5">
          <v-spacer />
          <v-btn text @click="clear"> Cancel </v-btn>
          <v-btn color="primary" @click="saveBillingAddress">
            <v-icon left>mdi-content-save-move</v-icon>
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  name: "billingInfo",
  data: function () {
    return {
      dialog: false,
      editable: false,
      formData: {
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        companyName: "",
        address1: "",
        address2: "",
        country: "",
        city: "",
        postalCode: "",
        pinNo: "",
        profileID: "",
        lineNo: "",
      },
    };
  },

  beforeRouteEnter(to, from, next) {
    next((v) => {
      v.$store.dispatch("Billing/getBillingAddresses");
    });
  },

  computed: {
    billingAddresses() {
      return this.$store.getters["Billing/billingAddresses"];
    },

    rules() {
      return {
        firstName: [(v) => !!v || "Required"],
        lastName: [(v) => !!v || "Required"],
        email: [
          (v) => !!v || "Required",
          (v) => /.+@.+/.test(v) || "E-mail must be valid",
        ],
        phone: [(v) => !!v || "Required"],
        address1: [(v) => !!v || "Required"],
        country: [(v) => !!v || "Required"],
        city: [(v) => !!v || "Required"],
        postalCode: [(v) => !!v || "Required"],
      };
    },
  },

  methods: {
    clear: function () {
      this.formData = {
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        companyName: "",
        address1: "",
        address2: "",
        country: "",
        city: "",
        postalCode: "",
        pinNo: "",
      };
      this.dialog = false;
      this.editable = false;
    },

    edit: function (payload) {
      this.formData = { ...payload };
      this.editable = true;
      this.dialog = true;
    },

    saveBillingAddress: function () {
      let isValid = true;
      for (const key in this.formData) {
        if (this.$refs[key])
          isValid = isValid ? this.$refs[key].validate(true) : false;
      }

      if (isValid) {
        this.$store.dispatch(
          this.editable
            ? "Billing/saveBillingAddress"
            : "Billing/createBillingAddress",
          {
            ...this.formData,
          },
        );
        this.clear();
      }
    },

    remove(item) {
      this.$confirm.show({
        title: "Remove this Address?",
        text: `Are you sure you want to remove?`,
        onConfirm: () => {
          this.$store.dispatch("Billing/removeBillingAddress", { ...item });
        },
      });
    },
  },
};
</script>

<style scoped>
.billing {
  font-family: "PT Sans Caption", sans-serif;
  cursor: progress;
  width: 100%;
  margin: 0 auto;
}
</style>
